import { Card } from 'react-bootstrap';
import { Outlet } from 'react-router-dom'
import { useTheme } from 'context/ThemeContext';
import SolarMoonBoldDuotone from 'components/icons/SolarMoonBoldDuotone';
import SolarSun2BoldDuotone from 'components/icons/SolarSun2BoldDuotone';
import SetLang, { canSwitchAppLang } from 'components/setLang';
 
const LoginLayout = () => {
    const { darkTheme, setDarkTheme } = useTheme();

    return (
        <div className="auth-main">
            <div className="auth-toolbar">
                {canSwitchAppLang() && <SetLang />}
                <button
                    type="button"
                    className="auth-theme-toggle"
                    onClick={() => setDarkTheme(!darkTheme)}
                    aria-label={darkTheme ? 'Enable light theme' : 'Enable dark theme'}
                    title={darkTheme ? 'Light theme' : 'Dark theme'}
                >
                    {darkTheme ? <SolarSun2BoldDuotone /> : <SolarMoonBoldDuotone />}
                </button>
            </div>
            <div className="auth-wrapper v1 justify-content-center">
                <div className="auth-form">
                    <Card className="my-5">
                        <Card.Body>
                            <Outlet/>
                        </Card.Body>
                    </Card>
                </div>
            </div>

        </div>
    );
};

export default LoginLayout;
